var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoProfilo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 19C31.5 23.1421 28.1421 26.5 24 26.5C19.8579 26.5 16.5 23.1421 16.5 19C16.5 14.8579 19.8579 11.5 24 11.5C28.1421 11.5 31.5 14.8579 31.5 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24ZM24 6.5C14.335 6.5 6.5 14.335 6.5 24C6.5 28.1336 7.93314 31.9324 10.3297 34.9267C12.1073 32.0631 16.0116 29 24 29C31.9884 29 35.8927 32.0631 37.6704 34.9268C40.0669 31.9324 41.5 28.1336 41.5 24C41.5 14.335 33.665 6.5 24 6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfilo);
export default __webpack_public_path__ + "static/media/ico-profilo.a0029103ca452141758c0767273c723a.svg";
export { ForwardRef as ReactComponent };